import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material';
import axios from 'axios';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './home/Home';
import ProfileRequirements from './profile/ProfileRequirements';
import Profile from './profile/Profile';
import ProfilePage from './member-services/ProfilePage'
import TutoringProfile from './profile/TutoringProfile';
import UploadTest from './profile/UploadTest';
import Events from './events/Events';
import Tutoring from './tutoring/Tutoring';
// import ReviewSheets from './tutoring/ReviewSheets';
// import TutoringFeedback from './tutoring/TutoringFeedback';
// import LogHours from './tutoring/LogHours';
import Team from './officers/Team';
import TestBank from './member-services/TestBank';
// import Corporate from './member-services/Corporate';
import InductionProgress from './candidates/InductionProgress';
import CandidateTracker from './admin/CandidateTracker';
import ManageUsers from './admin/ManageUsers';
import TutoringPhrase from './admin/TutoringPhrase';
import SignupForm from './signup/SignupForm';
import CandidateSpreadsheet from './admin/CandidateSpreadsheet';

import RouteProtection from './permissions/RouteProtection';
import { positions } from './permissions/PermissionsUtils';

import './App.css';
import FeatureInProgress from './FeatureInProgress';
import PasswordReset from './password-reset/PasswordReset';
import ChooseNewPassword from './password-reset/ChooseNewPassword';

const navTheme = createTheme({
  palette: {
    primary: {
      main: '#000',
      contrastText: '#fff',
    },
    secondary: {
      main: '#eec807',
    },
    text: {
      main: '#fff',
      primary: '#fff',
      secondary: '#AAA',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#000',
          borderRadius: 0,
        },
      },
    },
  },
});

let theme = createTheme({});
theme = createTheme({
  palette: {
    // white
    primary: {
      main: '#ffffff',
    },
    // gold/yellow
    secondary: {
      main: '#eec807',
    },
    // dark grey
    custom: {
      main: '#222',
    },
    // light grey
    custom2: {
      main: '#bdbdbd',
    },
  },
  typography: {
    p: {
      color: '#bdbdbd',
      fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontWeight: 400,
      fontSize: '1.2rem',
      lineHeight: 1.5,
      display: 'block',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
    h1: {
      color: 'white',
      fontWeight: 'bold',
      fontSize: '350%',
      lineHeight: 1.2,
      fontFamily: [
        '-apple-system,BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        '"Noto Sans"',
        'sans - serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"',
      ].join(','),
    },
    h2: {
      color: 'white',
      fontSize: '2.7rem',
      lineHeight: 1.2,
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        "'Segoe UI'",
        'Roboto',
        "'Helvetica Neue'",
        'Arial',
        "'Noto Sans'",
        'sans-serif',
        "'Apple Color Emoji'",
        "'Segoe UI Emoji'",
        "'Segoe UI Symbol'",
        "'Noto Color Emoji'",
      ].join(','),
      fontWeight: 400,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.7rem',
      },
    },
    h3: {
      fontSize: '1.6rem',
      lineHeight: 1.2,
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        "'Segoe UI'",
        'Roboto',
        "'Helvetica Neue'",
        'Arial',
        "'Noto Sans'",
        'sans-serif',
        "'Apple Color Emoji'",
        "'Segoe UI Emoji'",
        "'Segoe UI Symbol'",
        "'Noto Color Emoji'",
      ].join(','),
      fontWeight: 400,
    },
    h4: {
      fontSize: '1.3rem',
      lineHeight: 1.1,
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        "'Segoe UI'",
        'Roboto',
        "'Helvetica Neue'",
        'Arial',
        "'Noto Sans'",
        'sans-serif',
        "'Apple Color Emoji'",
        "'Segoe UI Emoji'",
        "'Segoe UI Symbol'",
        "'Noto Color Emoji'",
      ].join(','),
      fontWeight: 400,
    },
    highlight: {
      color: '#eec807',
    },
  },
});

function App() {
  const [authenticatedUser, setAuthenticatedUser] = useState(null);

  useEffect(() => {
    axios
      .get('/api/user/authenticated-user')
      .then((res) => setAuthenticatedUser(res.data.user))
      .catch((err) => setAuthenticatedUser(null));
  }, []);

  return (
    <>
      <ThemeProvider theme={navTheme}>
        <Navbar
          authenticatedUser={authenticatedUser}
          setAuthenticatedUser={setAuthenticatedUser}
        />
      </ThemeProvider>
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route path='' element={<Home />} />
            <Route path='reset-password' element={<PasswordReset />} />
            <Route path='reset-password/:id' element={<ChooseNewPassword />} />
            <Route path='mildcarrot3600' element={<SignupForm />} />
            <Route path='profile'>
              <Route path='' element={<Profile />} />
              <Route path='requirements' element={<ProfileRequirements />} />
              <Route path='tutoring' element={<TutoringProfile />} />
              <Route path='upload_test' element={<UploadTest />} />
            </Route>
            <Route path='events' element={<Events />} />
            <Route path='tutoring'>
              {/* <Route path='' element={<Navigate to='schedule' replace />} /> */}
              <Route path='' element={<Tutoring />} />
              {/* <Route path='review_sheets' element={<ReviewSheets />} /> */}
              {/* <Route path='feedback' element={<TutoringFeedback />} /> */}
              {/* <Route path='log_hours' eleemnt={<LogHours />} /> */}
            </Route>
            <Route path='team' element={<Team />} />
            <Route path='officers' element={<Navigate to='/team' replace />} />
            <Route path='faculty' element={<Navigate to='/team' replace />} />
            <Route path='candidates'>
              <Route
                path='requirements'
                element={
                  <RouteProtection
                    authenticatedUser={authenticatedUser}
                    allowedPositions={[positions.candidate]}
                  />
                }
              ></Route>
            </Route>
            {/* TODO: ADMIN STUFF */}
            <Route path='candidates'>
              <Route
                path='induction-progress'
                element={
                  <RouteProtection
                    authenticatedUser={authenticatedUser}
                    allowedPositions={[positions.candidate]}
                  />
                }
              >
                <Route
                  path=''
                  element={
                    <InductionProgress
                      candidate={authenticatedUser}
                      setCandidate={setAuthenticatedUser}
                    />
                  }
                />
              </Route>
            </Route>

            <Route path='admin'>
              <Route
                path='manage_users'
                element={
                  <RouteProtection
                    authenticatedUser={authenticatedUser}
                    allowedPositions={[positions.admin]}
                  />
                }
              >
                <Route path='' element={<ManageUsers />} />
              </Route>
            </Route>

            <Route path='officer'>
              <Route
                path='candidate_tracker'
                element={
                  <RouteProtection
                    authenticatedUser={authenticatedUser}
                    allowedPositions={[positions.officer, positions.admin]}
                  />
                }
              >
                <Route path='' element={<CandidateTracker />} />
              </Route>
              <Route
                path='tutoring_phrase'
                element={
                  <RouteProtection
                    authenticatedUser={authenticatedUser}
                    allowedPositions={[positions.officer, positions.admin]}
                  />
                }
              >
                <Route path='' element={<TutoringPhrase />} />
              </Route>
              <Route
                path='candidate_spreadsheet'
                element={
                  <RouteProtection
                    authenticatedUser={authenticatedUser}
                    allowedPositions={[positions.officer, positions.admin]}
                  />
                }
              >
                <Route path='' element={<CandidateSpreadsheet />} />
              </Route>
            </Route>

            <Route path='members'>
              <Route
                path='testbank'
                element={
                  <RouteProtection
                    authenticatedUser={authenticatedUser}
                    allowedPositions={[positions.member, positions.officer, positions.admin]}
                  />
                }
              >
                <Route
                  path=''
                  element={
                    <TestBank
                      user={authenticatedUser}
                      setUser={setAuthenticatedUser}
                    />
                  }
                />
              </Route>
              <Route
                path='profile'
                element={
                  <RouteProtection
                    authenticatedUser={authenticatedUser}
                    allowedPositions={[positions.member, positions.officer, positions.admin]}
                  />
                }
              >
                <Route
                  path=''
                  element={
                    <ProfilePage
                      user={authenticatedUser}
                    />
                  }
                />
              </Route>
            </Route>
            <Route path='in-progress' element={<FeatureInProgress />} />
          </Routes>
        </Router>
        <Footer />
      </ThemeProvider>
    </>
  );
}

export default App;
